module.exports = __webpack_public_path__ + "media/images/flags/16/Scotland-5646ee4f84d055713f725c3875171987.png";